import React, { useEffect, useState } from "react"
import { map, range, chunk, nth, get, isEmpty, size } from "lodash"
import { APIResponse } from "redux/apis/types"
import * as Formatter from "utils/Formatter"
import ClassNames from "classnames"
import { element } from "prop-types"
import { NewsModal } from "../../organisms/panel/newsList"

const list = (num: number) =>
  map(range(num), () => {
    return {}
  })

export const NewsListContent = () => (
  <ul className="news-list">
    {map(list(10), (val, key) => (
      <li key={key}>
        <div className="news-title">
          ＣＡＣＨＤが急騰、リクルートＨＤ売却で特別利益発生へ
        </div>
        <div className="time-col right-justify">08/02 06:17</div>
      </li>
    ))}
  </ul>
)

type NewsListContentType = {
  list: [] | Array<APIResponse.Res>
  page: number
  current: number
  openModal?: Function
  className?: string
  isNewsTab?: boolean
  active?: number
  changeActive?: Function
  acquiredSeparatelyFlag?: boolean //取得件数指定の場合のフラグ
}

export const NewsListContents = (props: NewsListContentType) => {
  const lists = chunk(props.list, props.page)

  useEffect(() => {
    if (props.acquiredSeparatelyFlag) {
      if (!props.isNewsTab || isEmpty(props.list)) return
      props.openModal(props.list[0])
    } else {
      const data = nth(lists, props.current)
      if (!props.isNewsTab || isEmpty(data)) return
      props.openModal(data[0])
    }
  }, [props.list])

  return (
    <ul className={ClassNames(props.className)}>
      {map(
        props.acquiredSeparatelyFlag ? props.list : nth(lists, props.current),
        (val, key) => (
          <li
            className={ClassNames({ active: key === props.active })}
            key={key}
            onClick={() => {
              if (props.openModal) {
                props.openModal(val)
              }
              props.changeActive && props.changeActive(key)
            }}
          >
            <div className="news-time">
              {Formatter.date(get(val, "UpdTime"), "MM/DD HH:mm")}
            </div>
            <div className="news-title">{get(val, "Title", "-")}</div>
          </li>
        )
      )}
    </ul>
  )
}

export const SpNewsListContents = (props: {
  className: string
  lists: Array<APIResponse.Res>
  openModal: Function
  func?: Function
  btnDisable?: boolean
}) => {
  const { className, lists, openModal } = props
  return (
    <ul className={ClassNames(className)}>
      {map(lists, (val, key) => (
        <li
          //  className={ClassNames({ active: key === props.active })}
          key={key}
          onClick={() => {
            if (openModal) {
              openModal(val)
            }
            //  props.changeActive && props.changeActive(key)
          }}
        >
          <div className="news-title">{get(val, "Title", "-")}</div>
          <div className="news-time">
            {Formatter.date(get(val, "UpdTime"), "MM/DD HH:mm")}
          </div>
        </li>
      ))}
      {props.func && (
        <li>
          <div
            className={ClassNames(
              "btn btn-primary btn-shaped btn-news-symbol-more",
              {
                disabled: props.btnDisable,
              }
            )}
            onClick={() => props.func()}
          >
            もっと見る
          </div>
        </li>
      )}
    </ul>
  )
}

export const SymbolDetailMoalNewsListContents = (props: {
  list: Array<APIResponse.Res>
  changeActive: Function
  active: number
  className?: string
  onHide?: Function
  onClick?: Function
}) => {
  const [modalData, setModalData] = useState({})
  return (
    <>
      <ul className={ClassNames(props.className)}>
        {map(props.list, (val, index: number) => (
          <li
            // className={ClassNames({ active: index === props.active })}
            key={index}
            // onClick={() => {
            //   props.changeActive && props.changeActive(index)
            // }}
            onClick={() => {
              setModalData(props.list[index])
              props.onClick && props.onClick()
            }}
          >
            <div className="news-time">
              {Formatter.date(get(val, "UpdTime"), "MM/DD HH:mm")}
            </div>
            <div className="news-title">{get(val, "Title", "-")}</div>
          </li>
        ))}
      </ul>
      <NewsModal
        show={!!size(modalData)}
        onHide={() => {
          props.onHide && props.onHide()
          setModalData({})
        }}
        data={modalData}
      />
    </>
  )
}

const dummyContent =
  "トレードワークスグループは、証券システム開発事業とこれらに付帯する外国為替証拠金取引（FX）システム事業及びセキュリティ診断事業を展開する。証券システム事業において、同社は「TradeAgent」、「Athena」及び「Mars Web」を 主力製品と位置づけ、証券会社や金融情報システムサービス会社向けのシステムの開発・保守・運用を行う。"
export const CompanyOverview = (props: { content?: string }) => {
  return (
    <div className="description-area">
      <div className="description-title">企業概況</div>
      <div className="description-content">
        {props.content ? props.content : dummyContent}
      </div>
    </div>
  )
}
